import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import {
  Autoplay,
  Navigation,
  Pagination,
  EffectCoverflow,
} from 'swiper/modules'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('swiperModules', {
    Autoplay,
    Navigation,
    Pagination,
    EffectCoverflow,
  })
})
